import { createContext, useState, useContext, useRef } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const timerRef = useRef(null);
  const defaultMinTime = 500;
  const minTimeRef = useRef(defaultMinTime);

  const showLoader = (minTime = defaultMinTime, customMessage = '') => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }
    minTimeRef.current = minTime;
    setMessage(customMessage); // mensaje
    setLoading(true);
  };

  const hideLoader = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }

    timerRef.current = setTimeout(() => {
      setLoading(false);
      setMessage(''); // Limpiamos mensaje
    }, minTimeRef.current);
  };

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
      {loading && <Loader message={message} />}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => {
  return useContext(LoaderContext);

};

const Loader = ({ message }) => {
  return (
    <div style={{ ...styles.overlay, ...styles.fadeIn }}>
      <div style={styles.content}>
        <img src="/loader_transparent.gif" alt="Loading..." style={styles.loader} />
        {message && <p style={styles.message}>{message}</p>}
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    background: 'rgb(255, 255, 255)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    zIndex: 9999,
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.5s ease-in-out',
  },
  fadeIn: {
    opacity: 1,
    pointerEvents: 'auto',
  },
  content: {
    textAlign: 'center',
  },
  loader: {
    width: 100,
    height: 100,
  },
  message: {
    marginTop: 20,
    fontSize: 18,
    color: '#333',
    transition: 'opacity 0.5s ease-in-out', // 👈 También transición para mensaje
  },
};